/* eslint-disable @typescript-eslint/no-explicit-any */
import { AlertTriangle, Ban, Lock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { EntitlementsResponse } from '@/types/backend'

type Props = {
  ent?: EntitlementsResponse
  onRenew?: () => void
  onLogout?: () => void
}

export function AccountGateBanner({ ent, onRenew, onLogout }: Props) {
  if (!ent?.ok) return null

  const account = (ent as any).account ?? {}

  const isInactive = account.isActive === false
  const isSuspended = !!account.suspendedAt
  const cannotWrite = !ent.canWrite

  // priorité 1 — compte désactivé (hard block)
  if (isInactive) {
    return (
      <div className='border-b bg-red-50 text-red-900 dark:bg-red-950/30 dark:text-red-200'>
        <div className='px-4 md:px-6 py-3 flex items-start gap-3'>
          <Ban className='h-5 w-5 mt-0.5' />
          <div className='flex-1'>
            <div className='font-medium'>Compte désactivé</div>
            <div className='text-sm opacity-80'>
              Accès bloqué. Contacte le support.
            </div>
          </div>
          {onLogout && (
            <Button size='sm' variant='outline' onClick={onLogout}>
              Déconnexion
            </Button>
          )}
        </div>
      </div>
    )
  }

  // priorité 2 — suspendu (billing/support action)
  if (isSuspended) {
    return (
      <div className='border-b bg-yellow-50 text-yellow-900 dark:bg-yellow-950/30 dark:text-yellow-200'>
        <div className='px-4 md:px-6 py-3 flex items-start gap-3'>
          <Lock className='h-5 w-5 mt-0.5' />
          <div className='flex-1'>
            <div className='font-medium'>Compte suspendu — lecture seule</div>
            <div className='text-sm opacity-80'>
              {account.suspensionReason ??
                'Contacte le support pour régulariser.'}
            </div>
          </div>
        </div>
      </div>
    )
  }

  // priorité 3 — abonnement expiré (soft block)
  if (cannotWrite) {
    return (
      <div className='border-b bg-background'>
        <div className='px-4 md:px-6 py-3 flex items-start gap-3'>
          <AlertTriangle className='h-5 w-5 mt-0.5' />
          <div className='flex-1'>
            <div className='font-medium'>Abonnement expiré</div>
            <div className='text-sm opacity-80'>
              Lecture seule tant que le paiement n’est pas régularisé.
            </div>
          </div>
          {onRenew && (
            <Button size='sm' onClick={onRenew}>
              Renouveler
            </Button>
          )}
        </div>
      </div>
    )
  }

  return null
}
